// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%236e7786%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpolyline points=%276 9 12 15 18 9%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;500;600;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Open Sans", sans-serif;
}
/* Form container */
.form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

/* Form heading */
form h2 {
  text-align: center;
  margin-bottom: 1.5rem;
}

/* Inputs and selects */
form input,
form select {
  display: block;
  width: 100%;
  margin-bottom: 1rem;
  padding: 0.5rem;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-sizing: border-box;
}

/* Label styling */
form label {
  font-weight: bold;
  margin-bottom: 0.3rem;
  display: block;
}

/* Checkbox styling */
form input[type="checkbox"] {
  width: auto;
  margin-right: 0.5rem;
  display: inline-block;
}

/* Input focus styling */
form input:focus,
form select:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.2);
}

/* Submit button styling */
form button {
  width: 100%;
  padding: 0.75rem;
  background-color: #007bff;
  color: white;
  font-size: 1rem;
  font-weight: bold;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
}

form button:hover {
  background-color: #0056b3;
}

/* Loader spinner */
.spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-right: 8px;
  border: 2px solid #fff;
  border-top: 2px solid #007bff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  vertical-align: middle;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Modal overlay and content */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: #fff;
  /* padding: 0px; */
  border-radius: 12px;
  text-align: center;
  width: 450px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.25);
}

.modal-content-success {
  background: #fff;
  padding: 24px 32px;
  border-radius: 12px;
  text-align: center;
  width: 320px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.25);
}



.modal-buttons {
  margin-top: 20px;
}

.modal-buttons button {
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: bold;
  background-color: #007bff;
  color: white;
  font-size: 1rem;
}

.modal-buttons button:hover {
  background-color: #0056b3;
}

/* Page layout */
.page-container {
  display: flex;
  min-height: 100vh;
  /* background: #f5f7fb; */
  /* font-family: "Inter", sans-serif; */
}
 
/* Left form card */
.form-card {
  /* max-width: 520px; */
  margin: auto;
  padding: 20px;
  /* background: #ffffff; */
  border-radius: 12px;
  /* box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08); */
}

.form-card-addition {
  /* max-width: 520px; */
  margin: auto;
  /* background: #ffffff; */
  border-radius: 12px;
  /* box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08); */
  width: 500px;
}
 
.title {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #27344a;
}
 
.title span {
  color: #0052cc;
}
 
.group-logo {
  width: 100px;
  display: block;
  margin-bottom: 24px;
}
 
/* Form styling */
.form {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
 
.field-row {
  display: flex;
  gap: 12px;
}


.field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1 1;
}

.field-addition {
  display: flex;
  flex-direction: column;
  flex: 1 1;
}

.field label {
  font-size: 15px;
  font-weight: 500;
  color: #161a1d;
}

.field input,
.field select {
  padding: 12px 40px 12px 14px;
  font-size: 14px;
  border-radius: 8px;
  border: 1px solid #d5d7da;
  background: #fff;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.field select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
 
  padding: 12px 40px 12px 14px;
 
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 16px center;
  background-size: 12px;
}

.field input:focus,
.field select:focus {
  border-color: #0052cc;
  box-shadow: 0 0 0 3px rgba(0, 82, 204, 0.15);
  outline: none;
}
 
input,
select {
  width: 100%;
  padding: 12px 14px;
  border-radius: 6px;
  border: 1px solid #d5d7da;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
}
 
input:focus,
select:focus {
  border-color: #0052cc;
  box-shadow: 0 0 0 2px rgba(0, 82, 204, 0.15);
}
 
.label {
  font-size: 13px;
  font-weight: 500;
  color: #525d6e;
  margin-top: 6px;
}
 
button {
  margin-top: 16px;
  padding: 12px;
  background: #0052cc;
  color: #ffffff;
  border: none;
  border-radius: 6px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
}
 
button:disabled {
  background: #8aafe8;
  cursor: not-allowed;
}
 
.error {
  /* color: #fb3640; */
  font-size: 13px;
}

.modal-heading {
  margin-left: 12px;
  text-align: left;
  font-size: 16px;
  border-bottom: 1px solid #e1e4e8;
  padding-bottom: 8px;
}

.modal-footer {
  border-top: 1px solid #e1e4e8;
  margin-bottom: 12px;
  display: flex;
  justify-content: flex-end;
  margin-right: 12px;
}
 
/* Right image panel */
.image-panel {
  width: 58%;
  background-image: url("https://learning.safetyacademy.com/api/medias/group/6712a56658a79f4b29a8d181/backgroundImage?company=6712a56658a79f4b29a8d17d&_=1737256145248");
  background-size: auto;
  background-position: right;
  position: relative;
}
 
.image-overlay h3 {
  font-size: 28px;
  margin-bottom: 8px;
}
 
.image-overlay p {
  font-size: 14px;
  opacity: 0.9;
}

.subtitle {
  font-size: 14px;
  color: #6e7786;
  margin-bottom: 24px;
}

.password-field {
  position: relative;
  width: 100%;
}

.password-field input {
  width: 100%;
  padding-right: 40px; /* space for eye icon */
}

.password-toggle {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #666;
  font-size: 18px;
}

.password-toggle:hover {
  color: #000;
}
 
/* Responsive */
@media (max-width: 900px) {
  .page-container {
    flex-direction: column;
  }
 
  .form-card,
  .image-panel {
    width: 100%;
  }
 
  .image-panel {
    min-height: 240px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/CreateUserForm.css"],"names":[],"mappings":"AACA;EACE,oCAAoC;AACtC;AACA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB;;EAEE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA,wBAAwB;AACxB;;EAEE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,8BAA8B;AAC9B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,0CAA0C;AAC5C;;;;AAIA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,iBAAiB;EACjB,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA,mBAAmB;AACnB;EACE,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,iDAAiD;EACjD,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;;EAErB,4BAA4B;;EAE5B,yDAAmR;EACnR,4BAA4B;EAC5B,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;EACrB,4CAA4C;EAC5C,aAAa;AACf;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,8CAA8C;AAChD;;AAEA;;EAEE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,UAAU;EACV,sKAAsK;EACtK,qBAAqB;EACrB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB,EAAE,uBAAuB;AAC9C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;500;600;700&display=swap\");\nbody {\n  font-family: \"Open Sans\", sans-serif;\n}\n/* Form container */\n.form {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n/* Form heading */\nform h2 {\n  text-align: center;\n  margin-bottom: 1.5rem;\n}\n\n/* Inputs and selects */\nform input,\nform select {\n  display: block;\n  width: 100%;\n  margin-bottom: 1rem;\n  padding: 0.5rem;\n  font-size: 1rem;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  box-sizing: border-box;\n}\n\n/* Label styling */\nform label {\n  font-weight: bold;\n  margin-bottom: 0.3rem;\n  display: block;\n}\n\n/* Checkbox styling */\nform input[type=\"checkbox\"] {\n  width: auto;\n  margin-right: 0.5rem;\n  display: inline-block;\n}\n\n/* Input focus styling */\nform input:focus,\nform select:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.2);\n}\n\n/* Submit button styling */\nform button {\n  width: 100%;\n  padding: 0.75rem;\n  background-color: #007bff;\n  color: white;\n  font-size: 1rem;\n  font-weight: bold;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background-color 0.2s ease-in-out;\n}\n\nform button:hover {\n  background-color: #0056b3;\n}\n\n/* Loader spinner */\n.spinner {\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  margin-right: 8px;\n  border: 2px solid #fff;\n  border-top: 2px solid #007bff;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n  vertical-align: middle;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Modal overlay and content */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.4);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background: #fff;\n  /* padding: 0px; */\n  border-radius: 12px;\n  text-align: center;\n  width: 450px;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.25);\n}\n\n.modal-content-success {\n  background: #fff;\n  padding: 24px 32px;\n  border-radius: 12px;\n  text-align: center;\n  width: 320px;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.25);\n}\n\n\n\n.modal-buttons {\n  margin-top: 20px;\n}\n\n.modal-buttons button {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-weight: bold;\n  background-color: #007bff;\n  color: white;\n  font-size: 1rem;\n}\n\n.modal-buttons button:hover {\n  background-color: #0056b3;\n}\n\n/* Page layout */\n.page-container {\n  display: flex;\n  min-height: 100vh;\n  /* background: #f5f7fb; */\n  /* font-family: \"Inter\", sans-serif; */\n}\n \n/* Left form card */\n.form-card {\n  /* max-width: 520px; */\n  margin: auto;\n  padding: 20px;\n  /* background: #ffffff; */\n  border-radius: 12px;\n  /* box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08); */\n}\n\n.form-card-addition {\n  /* max-width: 520px; */\n  margin: auto;\n  /* background: #ffffff; */\n  border-radius: 12px;\n  /* box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08); */\n  width: 500px;\n}\n \n.title {\n  font-size: 24px;\n  font-weight: 600;\n  margin-bottom: 8px;\n  color: #27344a;\n}\n \n.title span {\n  color: #0052cc;\n}\n \n.group-logo {\n  width: 100px;\n  display: block;\n  margin-bottom: 24px;\n}\n \n/* Form styling */\n.form {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n \n.field-row {\n  display: flex;\n  gap: 12px;\n}\n\n\n.field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  flex: 1;\n}\n\n.field-addition {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n\n.field label {\n  font-size: 15px;\n  font-weight: 500;\n  color: #161a1d;\n}\n\n.field input,\n.field select {\n  padding: 12px 40px 12px 14px;\n  font-size: 14px;\n  border-radius: 8px;\n  border: 1px solid #d5d7da;\n  background: #fff;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.field select {\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n \n  padding: 12px 40px 12px 14px;\n \n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%236e7786' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 16px center;\n  background-size: 12px;\n}\n\n.field input:focus,\n.field select:focus {\n  border-color: #0052cc;\n  box-shadow: 0 0 0 3px rgba(0, 82, 204, 0.15);\n  outline: none;\n}\n \ninput,\nselect {\n  width: 100%;\n  padding: 12px 14px;\n  border-radius: 6px;\n  border: 1px solid #d5d7da;\n  font-size: 14px;\n  outline: none;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n \ninput:focus,\nselect:focus {\n  border-color: #0052cc;\n  box-shadow: 0 0 0 2px rgba(0, 82, 204, 0.15);\n}\n \n.label {\n  font-size: 13px;\n  font-weight: 500;\n  color: #525d6e;\n  margin-top: 6px;\n}\n \nbutton {\n  margin-top: 16px;\n  padding: 12px;\n  background: #0052cc;\n  color: #ffffff;\n  border: none;\n  border-radius: 6px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n}\n \nbutton:disabled {\n  background: #8aafe8;\n  cursor: not-allowed;\n}\n \n.error {\n  /* color: #fb3640; */\n  font-size: 13px;\n}\n\n.modal-heading {\n  margin-left: 12px;\n  text-align: left;\n  font-size: 16px;\n  border-bottom: 1px solid #e1e4e8;\n  padding-bottom: 8px;\n}\n\n.modal-footer {\n  border-top: 1px solid #e1e4e8;\n  margin-bottom: 12px;\n  display: flex;\n  justify-content: flex-end;\n  margin-right: 12px;\n}\n \n/* Right image panel */\n.image-panel {\n  width: 58%;\n  background-image: url(\"https://learning.safetyacademy.com/api/medias/group/6712a56658a79f4b29a8d181/backgroundImage?company=6712a56658a79f4b29a8d17d&_=1737256145248\");\n  background-size: auto;\n  background-position: right;\n  position: relative;\n}\n \n.image-overlay h3 {\n  font-size: 28px;\n  margin-bottom: 8px;\n}\n \n.image-overlay p {\n  font-size: 14px;\n  opacity: 0.9;\n}\n\n.subtitle {\n  font-size: 14px;\n  color: #6e7786;\n  margin-bottom: 24px;\n}\n\n.password-field {\n  position: relative;\n  width: 100%;\n}\n\n.password-field input {\n  width: 100%;\n  padding-right: 40px; /* space for eye icon */\n}\n\n.password-toggle {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  cursor: pointer;\n  color: #666;\n  font-size: 18px;\n}\n\n.password-toggle:hover {\n  color: #000;\n}\n \n/* Responsive */\n@media (max-width: 900px) {\n  .page-container {\n    flex-direction: column;\n  }\n \n  .form-card,\n  .image-panel {\n    width: 100%;\n  }\n \n  .image-panel {\n    min-height: 240px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
